enum StatusCardType {
  OrderPlaced,
  PurchaseInProgress,
  Purchased,
  Reserved
}

export default StatusCardType;
